import {
  Box,
  Button,
  FormLabel,
  HStack,
  Input,
  Spinner,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import { brandPalette } from "../../../../constants/brandPalette";

import { getPaymentSubjectRequest } from "../../../../modules/admin-modules/videos/Actions";

/** API datetime → value for input[type=datetime-local] */
function apiDateToDatetimeLocal(val) {
  if (val == null || val === "") return "";
  const s = String(val).trim();
  const m = s.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})(:\d{2})?/);
  if (m) return `${m[1]}T${m[2]}`;
  const d = new Date(s);
  if (!Number.isNaN(d.getTime())) {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
  return "";
}

const datetimeInputProps = {
  bg: "var(--surface-muted)",
  color: "var(--text-primary)",
  borderRadius: "12px",
  border: "1px solid",
  borderColor: "var(--border-subtle)",
};

function RadioErrorBox({ error, fieldName, children }) {
  return (
    <Box
      w="100%"
      data-exam-field={fieldName}
      p={error ? 3 : 0}
      borderRadius="md"
      borderWidth={error ? "1px" : "0"}
      borderColor={error ? "red.400" : "transparent"}
      bg={error ? "red.50" : "transparent"}
    >
      {children}
      {error ? (
        <Text color="red.500" fontSize="sm" fontWeight="600" mt={2}>
          {error}
        </Text>
      ) : null}
    </Box>
  );
}

const StepOne = ({
  data,
  register,
  errors,
  isFormOne,
  watchTimer,
  setValue,
  watchType,
  isAdd,
}) => {
  const pdfField = register("pdf");
  const [pdfLabel, setPdfLabel] = useState("");
  const colourStyles = (hasError) => ({
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
      borderColor: hasError ? "#E53E3E" : styles.borderColor,
      boxShadow: hasError ? "0 0 0 1px #E53E3E" : undefined,
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  });
  const videos = useSelector((state) => state.videos.videos);
  const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);
  const videosLoading = useSelector((state) => state.videos.isLoading);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPaymentSubjectRequest());
  }, []);

  useEffect(() => {
    register("video_id", {
      required: String(watchType) === "6" ? "Select a video" : false,
    });
  }, [register, watchType]);

  useEffect(() => {
    if (data?.video?.id) setValue("video_id", data.video.id);
  }, [data?.video?.id, setValue]);

  const paymentSubjectsOptions = paymentSubjects?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const videosOptions = videos?.map((data) => {
    return { value: data.id, label: data.title };
  });
  return (
    <VStack
      dir="ltr"
      w="100%"
      flexWrap="wrap"
      justifyContent="space-between"
      spacing="50px"
      display={isFormOne ? "flex" : "none"}
    >
      {videosLoading && (
        <HStack w="100%" spacing={3} color="var(--text-muted)">
          <Spinner size="sm" color={brandPalette.primary} />
          <Text fontSize="sm" fontWeight="600">
            Loading videos and payment subjects...
          </Text>
        </HStack>
      )}
      <Box w="100%">
        <MainInput
          label="Assignment title"
          defaultValues={data.name}
          error={errors?.name?.message}
          placeholder="Enter assignment title"
          register={register}
          name="name"
          requiredMessage="This field is required"
        />
      </Box>

      <HStack w="100%" alignItems="flex-start" spacing={6}>
        <Box flex="1" minW={0}>
          <FormLabel>Start time</FormLabel>
          <Input
            type="datetime-local"
            {...register("start_time")}
            defaultValue={apiDateToDatetimeLocal(data?.start_time)}
            {...datetimeInputProps}
          />
        </Box>
        <Box flex="1" minW={0}>
          <FormLabel>End time (optional)</FormLabel>
          <Input
            type="datetime-local"
            {...register("end_time")}
            defaultValue={apiDateToDatetimeLocal(data?.end_time)}
            {...datetimeInputProps}
          />
        </Box>
      </HStack>

      <HStack w="100%" alignItems="flex-start">
        <VStack w="50%" alignItems="flex-start">
          <FormLabel>Add a timer for this assignment:</FormLabel>
          <RadioErrorBox fieldName="timer" error={errors?.timer?.message}>
          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("timer", { required: "This field is required" })}
                type="radio"
                value="0"
                defaultChecked={data?.timer == 0 ? true : false}
              />
              No
            </label>
            <label>
              <input
                {...register("timer", { required: "This field is required" })}
                type="radio"
                value="1"
                defaultChecked={data?.timer == 1 ? true : false}
              />
              Yes
            </label>
          </Stack>
          </RadioErrorBox>
        </VStack>

        {watchTimer == 1 && (
          <HStack w="75%">
            <FormLabel w="50%">Timer duration:</FormLabel>

            <MainInput
              label=""
              required={watchTimer == 1}
              requiredMessage="This field is required"
              defaultValues={data.time}
              error={errors?.time?.message}
              placeholder="Enter exam duration"
              register={register}
              name="time"
            />
          </HStack>
        )}
        <Box w="100%" paddingLeft={10}>
          <FormLabel>Publishing:</FormLabel>
          <RadioErrorBox fieldName="published" error={errors?.published?.message}>
          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("published", {
                  required: "This field is required",
                })}
                type="radio"
                value="0"
                defaultChecked={isAdd ? true : data?.published == 0 ? true : false}
              />
              Publish exam
            </label>
            <label>
              <input
                {...register("published", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.published == 1 ? true : false}
              />
              Do not publish
            </label>
          </Stack>
          </RadioErrorBox>
        </Box>
        <Box w="100%">
          <FormLabel>Activation:</FormLabel>
          <RadioErrorBox fieldName="enable" error={errors?.enable?.message}>
          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("enable", {
                  required: "This field is required",
                })}
                type="radio"
                value="0"
                defaultChecked={isAdd ? true : data?.enable == 0 ? true : false}
              />
              Enable assignment
            </label>
            <label>
              <input
                {...register("enable", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.enable == 1 ? true : false}
              />
              Disable assignment
            </label>
          </Stack>
          </RadioErrorBox>
        </Box>
      </HStack>
      <HStack w="100%" alignItems="flex-start">
        <Box w="100%">
          <FormLabel>Auto-publish results:</FormLabel>
          <RadioErrorBox fieldName="auto_publish_result" error={errors?.auto_publish_result?.message}>
          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("auto_publish_result", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.auto_publish_result == 1 ? true : false}
              />
              Publish results
            </label>
            <label>
              <input
                {...register("auto_publish_result", {
                  required: "This field is required",
                })}
                type="radio"
                value="0"
                defaultChecked={isAdd ? true : data?.auto_publish_result == 0 ? true : false}
              />
              Do not publish
            </label>
          </Stack>
          </RadioErrorBox>
        </Box>
        <Box w="100%">
          <FormLabel>Allow redo?</FormLabel>
          <RadioErrorBox fieldName="redo_flag" error={errors?.redo_flag?.message}>
          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("redo_flag", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.redo_flag == 1 ? true : false}
              />
              Allow redo
            </label>
            <label>
              <input
                {...register("redo_flag", {
                  required: "This field is required",
                })}
                type="radio"
                value="0"
                defaultChecked={isAdd ? true : data?.redo_flag == 0 ? true : false}
              />
              Do not allow
            </label>
          </Stack>
          </RadioErrorBox>
        </Box>
        <Box w="100%">
          <FormLabel>Importance:</FormLabel>
          <RadioErrorBox fieldName="book_mark" error={errors?.book_mark?.message}>
          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("book_mark", {
                  required: "This field is required",
                })}
                type="radio"
                value="0"
                defaultChecked={isAdd ? true : data?.book_mark == 0 ? true : false}
              />
              Regular
            </label>
            <label>
              <input
                {...register("book_mark", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.book_mark == 1 ? true : false}
              />
              Bookmarked
            </label>
          </Stack>
          </RadioErrorBox>
        </Box>
      </HStack>
      <HStack w="100%" alignItems="flex-start">
        <Box w="100%">
          <FormLabel>Assignment type:</FormLabel>
          <RadioErrorBox fieldName="type" error={errors?.type?.message}>
          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("type", { required: "This field is required" })}
                type="radio"
                value="1"
                defaultChecked={isAdd ? true : data?.type == 1 ? true : false}
              />
              Exam
            </label>
            <label>
              <input
                {...register("type", { required: "This field is required" })}
                type="radio"
                value="0"
                defaultChecked={data?.type == 0 ? true : false}
              />
              Quiz
            </label>
            <label>
              <input
                {...register("type", { required: "This field is required" })}
                type="radio"
                value="2"
                defaultChecked={data?.type == 2 ? true : false}
              />
              Homework/Classified
            </label>
            <label>
              <input
                {...register("type", { required: "This field is required" })}
                type="radio"
                value="6"
                defaultChecked={data?.type == 6 ? true : false}
              />
              Video exam
            </label>
            <label>
              <input
                {...register("type", { required: "This field is required" })}
                type="radio"
                value="7"
                defaultChecked={data?.type == 7 ? true : false}
              />
              Edutopia Practice{" "}
            </label>
            <label>
              <input
                {...register("type", { required: "This field is required" })}
                type="radio"
                value="5"
                defaultChecked={data?.type == 5 ? true : false}
              />
              Paper exam (center)
            </label>
          </Stack>
          </RadioErrorBox>
        </Box>

        {watchType == 6 && (
          <HStack w="100%" gap="30px" alignItems="flex-end">
            <Box w="100%" data-exam-field="video_id">
              <FormLabel>Select video:</FormLabel>
              <Select
                options={videosOptions}
                isMulti={false}
                isLoading={videosLoading}
                onChange={(data) => {
                  setValue("video_id", data?.value, { shouldValidate: true });
                }}
                styles={colourStyles(Boolean(errors?.video_id))}
                placeholder="Video"
                defaultValue={{
                  label: data?.video?.title,
                  value: data?.video?.id,
                }}
              />
              {errors?.video_id?.message ? (
                <Text color="red.500" fontSize="sm" fontWeight="600" mt={2}>
                  {errors.video_id.message}
                </Text>
              ) : null}
            </Box>
          </HStack>
        )}
      </HStack>
      <Box w="100%">
        <FormLabel>Assignment difficulty:</FormLabel>

        <Stack
          direction="row"
          role="group"
          aria-labelledby="my-radio-group"
          spacing="20px"
          flexWrap="wrap"
        >
          <label>
            <input
              {...register("difficulty")}
              type="radio"
              value="0"
              defaultChecked={isAdd ? true : data?.difficulty == 0}
            />
            All
          </label>
          <label>
            <input
              {...register("difficulty")}
              type="radio"
              value="1"
              defaultChecked={!isAdd && data?.difficulty == 1}
            />
            Easy
          </label>
          <label>
            <input
              {...register("difficulty")}
              type="radio"
              value="2"
              defaultChecked={data?.difficulty == 2}
            />
            Medium
          </label>
          <label>
            <input
              {...register("difficulty")}
              type="radio"
              value="3"
              defaultChecked={data?.difficulty == 3}
            />
            Hard
          </label>
        </Stack>
      </Box>
      <HStack w="100%">
        <Box w="100%" data-exam-field="payment_subject_id">
          <FormLabel>Payment subject:</FormLabel>
          <Select
            options={paymentSubjectsOptions}
            isMulti={false}
            isLoading={videosLoading}
            onChange={(data) => {
              setValue("payment_subject_id", data?.value, {
                shouldValidate: true,
              });
            }}
            styles={colourStyles(Boolean(errors?.payment_subject_id))}
            placeholder="Select payment subject"
            defaultValue={data?.payment_subject?.map((val) => {
              return { label: val?.name, value: val?.id };
            })}
          />
          {errors?.payment_subject_id?.message ? (
            <Text color="red.500" fontSize="sm" fontWeight="600" mt={2}>
              {errors.payment_subject_id.message}
            </Text>
          ) : null}
        </Box>
        <Box w="100%">
          <FormLabel>Passing score:</FormLabel>
          <Input
            {...register("success_score", { required: false })}
            type="number"
            placeholder="Enter passing score"
            defaultValue={data?.success_score}
            bg="#f5f5f5"
          />
        </Box>
      </HStack>
      <Box w="100%">
        <FormLabel>PDF file (optional)</FormLabel>
        <Button
          type="button"
          bg={brandPalette.primary}
          color="white"
          borderRadius="lg"
          position="relative"
          h="42px"
          w="100%"
          fontWeight="700"
          _hover={{ bg: brandPalette.accentDark }}
        >
          <Text noOfLines={1}>{pdfLabel || "Choose file to upload"}</Text>
          <Input
            {...pdfField}
            onChange={(e) => {
              pdfField.onChange(e);
              const file = e.target.files?.[0];
              setPdfLabel(file?.name || "");
            }}
            type="file"
            accept="application/pdf,.pdf"
            opacity="0"
            position="absolute"
            w="100%"
            h="100%"
            left={0}
            top={0}
            cursor="pointer"
          />
        </Button>
        {data?.pdf && typeof data.pdf === "string" && !pdfLabel ? (
          <Text fontSize="xs" color="var(--text-muted)" mt={1}>
            Current file: {String(data.pdf).split("/").pop()}
          </Text>
        ) : null}
        <Text color="red.500" fontSize="sm" fontWeight="600" mt={1}>
          {errors?.pdf?.message}
        </Text>
      </Box>
    </VStack>
  );
};

export default StepOne;
